import { all, fork } from 'redux-saga/effects'
import meSaga from './meSaga'
import rocketChatSagas from './rocketChatSaga'

export default function* rootSaga() {
  yield all([
    fork(meSaga),
    fork(rocketChatSagas)
  ])
}